import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { AddSimpleIcon, Block, CheckIcon, DeleteIcon, HiddenField, MyInfoIcon, SmallGrayText, ToolTipHover } from '@guryou/html-components';
import { RowActionButton } from 'modules/providers/performanceHub/components/studioPrimitives';
import { dealTokens, semanticActionColors, SystemIconButton, SystemTextInput } from 'components/shared';

const SelectStaff = () => {
  const { t } = useTranslation();
  const [staff, setStaff] = useState([]);
  const [singleStaff, setSingleStaff] = useState('');

  const handleAddStaff = () => {
    if (singleStaff && staff.length <= 2) {
      setStaff(prev => [...prev, { id: Date.now(), name: singleStaff }]);
      setSingleStaff('');
    }
  };

  const handleRemoveStaff = id => {
    setStaff(prevItems => prevItems.filter(item => item.id !== id));
  };
  return (
    <Block margin={0}>
      <Block margin={0} display="flex" flexDirection="row" alignItems="start" justifyContent="start">
        <SmallGrayText marginRight={2}>{t('ONBOARD.addStaffNames')}</SmallGrayText>
        <ToolTipHover textAlign="left" cleanToolTip={true} label={<MyInfoIcon fontSize="small" />} text={t('ONBOARD.youCanAddMoreLater')} />
      </Block>
      {staff?.map((x, index) => (
        // One added staff member: name on a success-tinted underline, the row's delete action
        // beside it — the same 30×30 RowActionButton every list row in the app uses.
        <div
          key={x.id}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 12,
            marginBottom: index === staff.length - 1 ? 16 : 8,
          }}
        >
          <div
            style={{
              flex: 1,
              minWidth: 0,
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              padding: '6px 0',
              borderBottom: `1px solid ${dealTokens.color.success}`,
              color: dealTokens.color.success,
            }}
          >
            <CheckIcon style={{ fontSize: 18 }} />
            <span style={{ fontSize: 14, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{x.name}</span>
            <HiddenField name="staffNames" value={x.name} />
          </div>
          <RowActionButton
            icon={<DeleteIcon style={{ fontSize: 15 }} />}
            title={t('ONBOARD.remove')}
            color={semanticActionColors.delete}
            onClick={() => handleRemoveStaff(x.id)}
          />
        </div>
      ))}
      {staff.length <= 1 && (
        <Block display="flex" flexDirection="row" alignItems="center" margin={0} marginBottom={4} style={{ gap: 8 }}>
          <SystemTextInput key={staff.length} placeholder={t('ONBOARD.enterStaffName')} value={singleStaff} onChange={val => setSingleStaff(val)} />
          <SystemIconButton icon={<AddSimpleIcon />} label={t('ONBOARD.add')} onClick={() => handleAddStaff()} />
        </Block>
      )}
    </Block>
  );
};

export default SelectStaff;
